export default __webpack_public_path__ + "static/media/s3.27715f68.svg";